<div class="main-wrapper">
	<ng-template [ngIf]="isActive$ | async">
		<h1 *ngIf="!hideTitle">{{ 'verification.title' | translate }}</h1>
		<iframe
			*ngIf="safeUrl$ | async as safeUrl"
			[src]="sanitizer.bypassSecurityTrustResourceUrl(safeUrl)"
			[useOverlayLoader]="useOverlayLoader"
			scrolling="yes"
			allowtransparency="false"
			obgIframe
			allow="camera; autoplay; fullscreen; clipboard-read; clipboard-write; accelerometer; gyroscope; magnetometer"
		>
		</iframe>
	</ng-template>
</div>
